import React from "react";
const IconMadeInCN = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56" fill="none" {...props}>
    <path
      d="M32.7435 49.9859C36.9106 47.7195 44.6704 43.1518 44.6518 34.0861"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="bevel"
    />
    <path
      d="M10.083 48.0021C15.426 45.0877 30.3722 37.7006 30.3 33.3154C30.2514 30.3622 25.896 29.1197 22.5543 28.6967"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="bevel"
    />
    <path
      d="M28.1068 6.01416C23.0334 8.29844 12.8867 14.3567 12.8867 20.3153C12.8867 26.2739 18.8959 28.3392 21.9005 28.6271"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
      strokeLinejoin="bevel"
    />
    <path
      d="M23.3721 28.3859V14.9614H27.6279V19.4578H31.8838V14.9614H36.1396V19.4578H40.3955V14.9614H44.6514V33.1425V34.6383H38.3456V26.8462C38.3456 24.5905 36.3844 22.7619 33.9653 22.7619C31.5461 22.7619 29.585 24.5905 29.585 26.8462V31.7989"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="bevel"
    />
    <path d="M12.8867 46.6585L12.8867 20.323" stroke="currentColor" strokeWidth="2" strokeLinejoin="bevel" />
    <path
      d="M42.8085 8.08716L43.7573 7.7711L43.1251 5.87362L42.1764 6.18969L42.8085 8.08716ZM42.1764 6.18969C40.3465 6.79932 38.1608 8.07982 36.4237 9.62896C35.5512 10.4071 34.7631 11.2783 34.187 12.1988C33.6142 13.1143 33.2158 14.1357 33.2158 15.1934L35.2158 15.1934C35.2158 14.6351 35.4304 13.9821 35.8824 13.2598C36.3312 12.5426 36.9799 11.8127 37.7549 11.1216C39.3129 9.73219 41.2655 8.6012 42.8085 8.08716L42.1764 6.18969Z"
      fill="currentColor"
    />
  </svg>
);
export default IconMadeInCN;
